import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form, Input, Select, InputNumber, Switch } from 'antd';
import { IngredientAmountUnit, CatalogSource } from '@wellverse/shared-ts';
import { LocalizedContentTabs, normalizeTranslations } from '../../components/LocalizedContentTabs';

const LANG_FIELDS = [
  { key: 'name', label: 'Name', placeholder: 'Ingredient name', required: true },
];

export const IngredientCatalogCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'ingredient-catalog' });

  return (
    <Create resource="ingredient-catalog" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            translations: normalizeTranslations(values.translations, LANG_FIELDS),
          })
        }
      >
        <LocalizedContentTabs fields={LANG_FIELDS} />
        <Form.Item label="Category" name="category" rules={[{ required: true }]}>
          <Input placeholder="proteins, vegetables, grains..." />
        </Form.Item>
        <Form.Item label="Default Amount Unit" name="defaultAmountUnit" rules={[{ required: true }]} initialValue={IngredientAmountUnit.GRAM}>
          <Select>
            {Object.values(IngredientAmountUnit).map((u) => (
              <Select.Option key={u} value={u}>
                {u}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Default Amount (g)" name="defaultAmountGrams" rules={[{ required: true }]} initialValue={100}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Calories per 100g" name="caloriesPer100g" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Protein per 100g" name="proteinPer100g" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Fat per 100g" name="fatPer100g" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Carbs per 100g" name="carbsPer100g" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Fiber per 100g" name="fiberPer100g">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Sodium per 100g (mg)" name="sodiumPer100g">
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item label="Common Allergens" name="commonAllergens">
          <Select mode="tags" placeholder="e.g. gluten, dairy, nuts" />
        </Form.Item>
        <Form.Item label="Tags" name="tags">
          <Select mode="tags" placeholder="e.g. organic, lean" />
        </Form.Item>
        <Form.Item label="Source" name="source" initialValue={CatalogSource.MANUAL}>
          <Select placeholder="Select source">
            <Select.Option value={CatalogSource.MANUAL}>{CatalogSource.MANUAL}</Select.Option>
            <Select.Option value={CatalogSource.USDA}>{CatalogSource.USDA}</Select.Option>
            <Select.Option value={CatalogSource.CFS}>{CatalogSource.CFS}</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
      </Form>
    </Create>
  );
};
